import { MainContainer } from '@/components/atoms'
import {
  CreateSubscriptionForm,
  ExtendedConnectWalletButton,
  Section,
} from '@/components/molecules'
import { Box, Spacer } from '@chakra-ui/react'
import { useAccount } from 'wagmi'

export const CreateSubscription = ({ refetchSubs }) => {
  const { isConnected } = useAccount()

  return (
    <MainContainer>
      <Section
        title={'Create Subscription'}
        subTitle={
          <>
            Create a Subscription ID using your wallet address. <Spacer /> The
            Subscription ID will be used in your contract when requesting a
            random value.
          </>
        }
        alignItems={'stretch'}
      >
        <Box maxW={400}>
          {isConnected ? (
            <CreateSubscriptionForm
              refetchSubs={refetchSubs}
              p={4}
              w={'full'}
              maxW={'full'}
              border={'1px solid'}
              borderColor={'gray.200'}
              rounded={'md'}
              boxShadow={'base'}
            />
          ) : (
            <ExtendedConnectWalletButton
              text={
                'To create a Subscription please connect to your wallet first.'
              }
            />
          )}
        </Box>
      </Section>
    </MainContainer>
  )
}
